import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import FirebaseNodeSanitizerInstance from "./FirebaseNodeSanitizer";
import FirebaseBaseSession from "./FirebaseBaseSession";
import { getDatabase, ref, onValue, onChildAdded, onChildRemoved, onChildChanged, onDisconnect, set, remove, serverTimestamp, push, off } from "firebase/database";
import * as log from "loglevel";

var FirebaseChatSession = /*#__PURE__*/function (_FirebaseBaseSession) {
  _inherits(FirebaseChatSession, _FirebaseBaseSession);

  function FirebaseChatSession(userName, roomName, id) {
    var _this;

    _classCallCheck(this, FirebaseChatSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirebaseChatSession).call(this, id));
    _this.roomName = roomName;
    _this.userName = userName;
    _this.managePresence = false;
    return _this;
  }

  _createClass(FirebaseChatSession, [{
    key: "connect",
    value: function connect(accessData, connectHandler) {
      var _this2 = this;

      _get(_getPrototypeOf(FirebaseChatSession.prototype), "connect", this).call(this, accessData, function (error) {
        if (error !== void 0) {
          connectHandler(error);
          return;
        }

        _this2.addFirebaseConnectionStatusListener();

        connectHandler();
      });
    }
  }, {
    key: "addFirebaseConnectionStatusListener",
    value: function addFirebaseConnectionStatusListener() {
      var _this3 = this;

      var database = getDatabase(this.firebaseApp);
      var connectedRef = ref(database, ".info/connected");
      onValue(connectedRef, function (snap) {
        if (snap.val() === true) {
          log.trace("connected established!");

          if (_this3.managePresence) {
            log.trace("add user to presence node again!");

            _this3.addUserToPresenceNode(_this3.accessToken);
          }
        } else {
          log.warn("connection lost!");
        }

        if (_this3.connectionListener) {
          _this3.connectionListener({
            online: snap.val() === true
          });
        }
      });
    }
  }, {
    key: "getRoomNodeReference",
    value: function getRoomNodeReference(baseNode) {
      return this.getReference(baseNode, FirebaseNodeSanitizerInstance.encodeKey(this.roomName));
    }
  }, {
    key: "detachListeners",
    value: function detachListeners() {
      off(this.getRoomNodeReference("r"));
      off(this.getRoomNodeReference("ru"));
      off(this.getRoomNodeReference("lm"));
      off(this.getRoomNodeReference("uc"));
    }
  }, {
    key: "attachRoomStateListener",
    value: function attachRoomStateListener(roomStateListener) {
      var _this4 = this;

      log.trace("attach internal Room state listener");
      var roomStateRef = this.getRoomNodeReference("r");
      onValue(roomStateRef, function (snapshot) {
        roomStateListener(_this4.convertSnapshotToRoomState(snapshot.val()));
      });
    }
  }, {
    key: "convertSnapshotToRoomState",
    value: function convertSnapshotToRoomState(snapshotValue) {
      if (snapshotValue == null) {
        return snapshotValue;
      }

      return {
        custom: snapshotValue.c,
        status: snapshotValue.s,
        statusMetadata: snapshotValue.m
      };
    }
  }, {
    key: "attachRoomRosterListener",
    value: function attachRoomRosterListener(roomRosterListener) {
      var _this5 = this;

      log.trace("attach internal Room roster listener");
      var roomStateRef = this.getRoomNodeReference("ru");
      onChildAdded(roomStateRef, function (snapshot) {
        roomRosterListener({
          type: "add",
          value: _this5.convertSnapshotToRoomUser(snapshot)
        });
      });
      onChildRemoved(roomStateRef, function (snapshot) {
        roomRosterListener({
          type: "remove",
          value: _this5.convertSnapshotToRoomUser(snapshot)
        });
      });
      onChildChanged(roomStateRef, function (snapshot) {
        roomRosterListener({
          type: "update",
          value: _this5.convertSnapshotToRoomUser(snapshot)
        });
      });
    }
  }, {
    key: "convertSnapshotToRoomUser",
    value: function convertSnapshotToRoomUser(snapshot) {
      var snapshotValue = snapshot.val();

      if (snapshotValue == null) {
        return snapshotValue;
      }

      return {
        username: snapshotValue.u,
        attributes: snapshotValue.a
      };
    }
  }, {
    key: "attachRoomUsersCountListener",
    value: function attachRoomUsersCountListener(roomUserCountListener) {
      var _this6 = this;

      log.trace("attach internal Room users count listener");
      this.addNodeUpdateListener("uc", this.roomName, function (snapshot) {
        var roomUserCount = _this6.convertSnapshotToUserCount(snapshot);

        if (roomUserCount == null) {
          return;
        }

        roomUserCountListener(roomUserCount);
      });
    }
  }, {
    key: "convertSnapshotToUserCount",
    value: function convertSnapshotToUserCount(snapshot) {
      var snapshotValue = snapshot.val();

      if (snapshotValue == null) {
        return snapshotValue;
      }

      return {
        count: snapshotValue.c
      };
    }
  }, {
    key: "attachRoomMessagesListener",
    value: function attachRoomMessagesListener(roomMessagesListener) {
      var _this7 = this;

      log.trace("attach internal Room messages listener");
      this.addNodeUpdateListener("lm", this.roomName, function (snapshot) {
        var roomMessage = _this7.convertSnapshotToRoomMessage(snapshot);

        if (roomMessage == null) {
          return;
        }

        roomMessagesListener(roomMessage);
      });
    }
  }, {
    key: "attachConnectionListener",
    value: function attachConnectionListener(connectionListener) {
      this.connectionListener = connectionListener;
    }
  }, {
    key: "convertSnapshotToRoomMessage",
    value: function convertSnapshotToRoomMessage(snapshot) {
      var snapshotValue = snapshot.val();

      if (snapshotValue == null) {
        return snapshotValue;
      }

      return {
        username: snapshotValue.u,
        message: snapshotValue.m,
        attributes: snapshotValue.a,
        timestamp: snapshotValue.t,
        type: snapshotValue.y,
        metadata: snapshotValue.d
      };
    }
  }, {
    key: "addUserToPresenceNode",
    value: function addUserToPresenceNode(accessToken, addUserToPresenceNodeHandler) {
      var _this8 = this;

      log.trace("start adding user to presence Node!");
      var pushNode = push(this.getReference("p", FirebaseNodeSanitizerInstance.encodeKey(this.roomName) + "/" + FirebaseNodeSanitizerInstance.encodeKey(this.userName)));
      this.presenceNode = pushNode;
      onDisconnect(pushNode).remove().catch(function (err) {
        if (err) {
          log.error("could not establish onDisconnect event", err);
        }
      });
      var pushNodeContent = {
        t: serverTimestamp(),
        ut: accessToken
      };
      this.accessToken = accessToken;
      set(pushNode, pushNodeContent).then(function () {
        log.trace("user added to presence Node!");

        if (!addUserToPresenceNodeHandler) {
          return;
        }

        addUserToPresenceNodeHandler();
      }).catch(function (error) {
        if (error) {
          log.error("error adding session into precense node: " + error);
        } else {
          log.trace("user added to presence Node. Start managing presence!");
          _this8.managePresence = true;
        }

        if (!addUserToPresenceNodeHandler) {
          return;
        }

        addUserToPresenceNodeHandler(error);
      });
    }
  }, {
    key: "readRoomState",
    value: function readRoomState(readHandler) {
      var _this9 = this;

      onValue(this.getRoomNodeReference("r"), function (snapshot) {
        readHandler(_this9.convertSnapshotToRoomState(snapshot.val()));
      }, {
        onlyOnce: true
      });
    }
  }, {
    key: "removePresenceNode",
    value: function removePresenceNode(removePresenceNodeHandler) {
      if (this.presenceNode) {
        remove(this.presenceNode).then(function () {
          if (!removePresenceNodeHandler) {
            return;
          }

          removePresenceNodeHandler();
        }).catch(function (error) {
          if (error) {
            log.error("error removing presence node: " + error);
          }

          removePresenceNodeHandler(error);
        });
      }
    }
  }]);

  return FirebaseChatSession;
}(FirebaseBaseSession);

export { FirebaseChatSession as default };